import { render, staticRenderFns } from "./CommonQuote.vue?vue&type=template&id=e6c6c298"
import script from "./CommonQuote.vue?vue&type=script&lang=js"
export * from "./CommonQuote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports